import type { PinValidationRequest } from 'washday-sdk';
import { GET_SET_STAFF, GET_SET_USER } from '../utils/api';
import { delData, getData, postData, putData } from '../utils/api-service';
import WashdayClientSingleton from './WashdayClientSingleton';

export const getStoreStaffByIdV2 = async (storeID: string, staffId: string) => {
  try {
    const res = await WashdayClientSingleton.getInstance().staff.getStoreStaffById(storeID, staffId);
    return { ...res.data };
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const updateUserByIdV2 = async (userID: string, data: any) => {
  try {
    return await WashdayClientSingleton.getInstance().users.updateUserById(userID, data);
  } catch (e) {
    console.log('ERROR productBulkByStoreV2', e);
    throw e;
  }
};

export const updateStaffByIdV2 = async (storeId: string, userID: string, data: any) => {
  try {
    const res = await WashdayClientSingleton.getInstance().staff.updateStoreStaffById(storeId, userID, data);
    return { ...res.data };
  } catch (e) {
    console.log('ERROR updateStaffByIdV2', e);
    throw e;
  }
};


export const updateStoreStaffStoresV2 = async (storeId: string, staffId: string, allowedStoreIds: string[]) => {
  try {
    const res = await WashdayClientSingleton.getInstance().staff.updateStoreStaffStores(storeId, staffId, allowedStoreIds);
    return { ...res.data };
  } catch (e) {
    console.log('ERROR updateStoreStaffStoresV2', e);
    throw e;
  }
};

export const getUserStoreAccessV2 = async (userId: string) => {
  try {
    const res = await WashdayClientSingleton.getInstance().users.getUserStoreAccess(userId);
    return { ...res.data };
  } catch (e) {
    console.log('ERROR getUserStoreAccessV2', e);
    throw e;
  }
};



export const getStoreStaffV2 = async (storeID: string, query = '') => {
  try {
    const res = await WashdayClientSingleton.getInstance().staff.getStoreStaff(storeID, query);
    return { ...res.data };
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};


export const createStoreStaffV2 = async (storeID: string, data: any) => {
  try {
    const res = await WashdayClientSingleton.getInstance().staff.createStoreStaff(storeID, data);
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const deleteStoreStaffV2 = async (storeID: string, staffID: string) => {
  try {
    const res = await WashdayClientSingleton.getInstance().staff.deleteStoreStaffById(storeID, staffID);
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const getStoreStaff = async (storeID, query = '', t = () => { }) => {
  try {
    const res = await getData(`${GET_SET_STAFF(storeID)}?${query}`, null, t);
    return res?.data?.data?.staffs || [];
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return [];
  }
};

export const deleteStoreStaff = async (storeID, staffID, t = () => { }) => {
  try {
    const res = await delData(
      `${GET_SET_STAFF(storeID)}/${staffID}`,
      {},
      null,
      t('alerts.success')
    );
    return res?.data;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return null;
  }
};

//THIS IS THE wd.staff.getStoreStaffById (function getStoreStaffByIdV2)
export const getUserById = async (storeID, staffID, t = () => { }) => {
  try {
    return await getData(`${GET_SET_STAFF(storeID)}/${staffID}`, null, t);
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const updateUserById = async (storeID, staffID, data, t = () => { }) => {
  try {
    return await putData(`${GET_SET_STAFF(storeID)}/${staffID}`, data, null, t('alerts.success'));
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const createUser = async (storeID, data, t = () => { }) => {
  try {
    return await postData(`${GET_SET_STAFF(storeID)}`, data, null, t('alerts.success'));
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return false;
  }
};

export const updateUserByIDNoStore = async (userID, data, t = () => { }) => {
  try {
    return await putData(`${GET_SET_USER}/${userID}`, data, null, t('alerts.success'));
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};


export const validateUserPin = async (data: PinValidationRequest) => {
  try {
    return await WashdayClientSingleton.getInstance().users.validateUserPin(data);
  } catch (e) {
    throw e;
  }
};
